<mat-card style="overflow-x: auto">
  <mat-card-header>
    <mat-card-title>{{ 'Company.orgChart' | translate }} </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div #chartContainer id="chartContainer" style="height: 300px"></div>
  </mat-card-content>
</mat-card>
